import { useCallback, useState } from 'react';

import { fetchUploadDocument } from '../../fetch/fetchUploadDocument';

export default function useUploadDocument() {
  const [isPending, setIsPending] = useState(false);

  const uploadDocument = useCallback(async (file, session_id) => {
    setIsPending(true);
    try {
      return await fetchUploadDocument(file, session_id);
    } finally {
      setIsPending(false);
    }
  }, []);

  return { uploadDocument, isPending };
}

